import { useTracking, Options } from 'react-tracking';

import { trackCustomClickEvent, trackSystemEntityEvent } from '@bizzabo/entities';

interface SystemInfo {
    trackType: 'System';
    data: {
        systemName: string;
        description: unknown | string;
    };
}

interface ClickInfo {
    trackType: 'Click';
    data: { description?: unknown; [key: string]: unknown };
}

type EventData = SystemInfo | ClickInfo;

const safeStringify = (data: unknown) => {
    try {
        return JSON.stringify(data);
    } catch (e) {
        return '';
    }
};

const eventDispatch = (data: EventData) => {
    if (data.trackType === 'System') {
        trackSystemEntityEvent(data.data.systemName, safeStringify(data.data.description));
    } else if (data.trackType === 'Click') {
        data.data.description = safeStringify(data.data.description);
        trackCustomClickEvent(data.data);
    }
};

export const RingTracking: React.FC = ({ children }) => {
    const { Track } = useTracking({}, { dispatch: eventDispatch });

    return <Track>{children}</Track>;
};

const useTypeTracking = (
    trackingData?: Partial<EventData>,
    options?: Partial<Options<EventData>>
) => {
    const { Track, trackEvent } = useTracking<EventData>(trackingData, options);

    const trackSystemEvent = (data: { systemName: string; description: unknown | string }) => {
        trackEvent({
            trackType: 'System',
            data,
        });
    };

    const trackClickEvent = (data: { description?: unknown; [key: string]: unknown }) => {
        trackEvent({
            trackType: 'Click',
            data,
        });
    };

    return { Track, trackEvent, trackSystemEvent, trackClickEvent };
};

export default useTypeTracking;
